
import * as Styled from './HeadlineStyles';

enum Tags{
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
}
interface HeadlineProps{
  tag: keyof typeof Tags,
  children: any,
  [rest: string]: any;
}

const Headline = ({ tag, children, ...rest }: HeadlineProps) => {
  // @ts-ignore
  const Comp:any = Styled[tag];
  return (
    <Comp {...rest}>
      {children}
    </Comp>
  )
}

export default Headline;